const m = require('mithril');
const { Sortable } = require('@shopify/draggable');

const mod = {};

mod.oncreate = function (vnode) {
  const sortable = vnode.state.sortable = new Sortable(vnode.dom, {
    draggable: vnode.attrs.draggable,
    distance: 3,
    delay: 300,
    handle: vnode.attrs.handleClass,
  });

  // Handle the sort stop event
  sortable.on('sortable:stop', () => {
    if (typeof vnode.attrs.onsort === 'function') {
      vnode.attrs.onsort(sortable.getDraggableElementsForContainer(vnode.dom));
    }
  });

  // Hide the original element during dragging
  sortable.on('drag:start', (evt) => {
    evt.source.style.opacity = '0'; // Hide the original element
  });

  sortable.on('drag:stop', (evt) => {
    evt.source.style.opacity = ''; // Reset the opacity
  });

  // style the mirror
  sortable.on('mirror:created', (evt) => {
    const mirror = evt.mirror;
    const source = evt.source;

    const sourceStyle = window.getComputedStyle(source);

    mirror.style.width = sourceStyle.width;
    mirror.style.height = sourceStyle.height;
    mirror.style.boxSizing = sourceStyle.boxSizing;
    mirror.style.padding = sourceStyle.padding;
    mirror.style.border = sourceStyle.border;
    mirror.style.margin = sourceStyle.margin;
    mirror.style.opacity = 0.8;

  });
};

mod.onremove = function (vnode) {
  const sortable = vnode.state && vnode.state.sortable;
  if (!sortable || typeof sortable.destroy !== 'function') return;

  vnode.state.sortable = null;
  sortable.destroy();
};

mod.view = function (vnode) {
  return m(vnode.attrs.htmlElement || 'div', vnode.attrs, vnode.children);
};

module.exports = mod;
